module.exports = __webpack_public_path__ + "media/bakingrelay.ba34b737.mp3";